<template>
  <div class="">
    <el-row :gutter="20">
      <el-col :span="6">
        <div>
          <el-input
            v-model="key"
            placeholder="请输入关键字或词"
            class="input-with-select"
            size="small"
            suffix-icon="el-icon-search"
          />
        </div>
      </el-col>
      <el-col :span="18" class="btn">
        <div>
          <el-button
            type="primary"
            icon="el-icon-download"
            size="small"
            v-if="importRoleList.length"
            v-permission="['角色管理导入角色']"
            @click="importRoleClick"
            >导入模版角色</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-circle-plus-outline"
            size="small"
            v-permission="['角色管理新增角色']"
            @click="addRole"
            >新增角色</el-button
          >
        </div>
      </el-col>
    </el-row>
    <div class="container-table">
      <el-table
        ref="filterTable"
        v-loading="loading"
        stripe
        size="mini"
        :data="roleData"
        style="width: 100%"
        :header-cell-style="tableHeaderColor"
        border
        :cell-style="cellStyle"
      >
        <el-table-column prop="code" label="角色编号" width="265" />
        <el-table-column prop="name" label="角色名称" width="265">
          <template slot-scope="scope">
            <div style="font-size: 12px">{{ scope.row.name }}</div>
          </template>
        </el-table-column>
        <el-table-column label="权限">
          <template slot-scope="scope">
            <span>{{ pinjie(scope.row.authority_list) }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-link
              type="primary"
              :underline="false"
              class="edit"
              v-permission="['角色管理编辑角色']"
              @click="editRole(scope.row)"
              >编辑</el-link
            >
            <el-link
              type="primary"
              :underline="false"
              class="edit"
              style="font-size: 12px"
              v-permission="['角色管理删除角色']"
              @click="delRole(scope.row)"
              >删除</el-link
            >
            <el-link
              v-if="scope.row.enable"
              type="primary"
              :underline="false"
              style="font-size: 12px"
              >禁用</el-link
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--分页-->
    <div class="pages">
      <el-pagination
        samll
        background
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <!--创建角色-->
    <el-dialog
      v-if="roleDialogVisible"
      :visible.sync="roleDialogVisible"
      :close-on-click-modal="false"
      width="45%"
      center
      @close="cancel"
    >
      <div slot="title" class="title">{{ roleId ? "编辑" : "新增" }}角色</div>
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        class="proInfo"
        label-width="100px"
      >
        <el-form-item label="角色名称：" prop="name" size="mini">
          <el-input v-model="ruleForm.name" placeholder="请输入角色名称" />
        </el-form-item>
        <el-form-item label="角色编号：" prop="code" size="mini">
          <el-input v-model="ruleForm.code" placeholder="请输入角色编号" />
        </el-form-item>
        <el-form-item label="角色权限：" prop="authority" size="mini">
          <el-cascader
            v-model="ruleForm.authority"
            size="mini"
            :options="authorityData"
            :props="props"
            collapse-tags
            clearable
            style="width: 100%"
            @change="handleData"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          size="mini"
          type="primary"
          :loading="is_loading"
          @click="submitForm('ruleForm')"
          >保 存</el-button
        >
        <el-button size="mini" @click="cancel">取 消</el-button>
      </span>
    </el-dialog>
    <!--导入模板角色-->
    <importRole
      :import-role-visible="importRoleVisible"
      :import-role-list="importRoleList"
      :authority-data="authorityData"
      @childClose="childClose"
    />
  </div>
</template>

<script>
import {
  getRole,
  roleList,
  addRole,
  delRole,
  detailRole,
  editRole,
  inRoleList,
} from "@/api/roleModel";
import { getProjectId } from "@/utils/auth";
import ImportRole from "./component/importRole";
export default {
  name: "Role",
  components: {
    ImportRole,
  },
  data() {
    const __checkAppraisalCategoryid = (rule, value, callback) => {
      if (!this.isFirstLoad) {
        if (value.length === 0) {
          callback(new Error("请选择角色权限"));
        } else {
          callback();
        }
      } else {
        this.isFirstLoad = false;
      }
    };
    return {
      cellStyle: {
        textAlign: "center",
      },
      isFirstLoad: true,
      currentPage: 1,
      pageSize: 10,
      total: null,
      roleData: [],
      is_loading: false,
      proId: "",
      key: "",
      roleDialogVisible: false,
      importRoleVisible: false,
      ruleForm: {
        name: "",
        code: "",
        authority: [],
      },
      reqObj: {},
      roleId: "",
      authorityData: [], // 权限数据
      rules: {
        name: [{ required: true, message: "请输入角色名称", trigger: "blur" }],
        code: [{ required: true, message: "请输入角色编号", trigger: "blur" }],
        authority: [
          {
            required: true,
            validator: __checkAppraisalCategoryid,
            message: "请选择角色权限",
            trigger: "change",
          },
        ],
      },
      importRoleList: [],
      loading: false,
      props: {
        multiple: true,
        label: "label",
        value: "value",
        children: "children",
      },
    };
  },
  computed: {
    pinjie() {
      return function (val) {
        let arr = [];
        val.map((item) => {
          console.log(item);
          arr = arr.concat(item.value);
        });
        console.info(arr.join("、"));
        return arr.join("、");
      };
    },
  },
  watch: {
    key(value) {
      if (this.timer !== null) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(this.getRole, 500);
    },
  },
  created() {
    this.proId = getProjectId();
    this.getRole();
    this.getRoleList();
  },
  methods: {
    handleData(res) {
      if (res) {
        // console.log(res);
        const obj = {};
        res.map((item) => {
          const val = obj[item[0]];
          console.log(val);
          if (val) {
            val.push(item[1]);
            obj[item[0]] = val;
          } else {
            const array = [];
            array.push(item[1]);
            obj[item[0]] = array;
          }
        });
        // console.log(obj);
        this.reqObj = obj;
        console.log('------------>',this.reqObj)
      }
    },
    importRoleClick() {
      this.list();
      this.importRoleVisible = true;
      event.stopPropagation();
    },
    list() {
      inRoleList({ project_id: this.proId })
        .then((res) => {
          if (res && res.code === 0) {
            if (res.data && res.data.length > 0) {
              this.importRoleList = res.data;
            } else {
              this.importRoleList = [];
            }
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    childClose() {
      this.importRoleVisible = false;
    },
    // 每页条数
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getRole();
    },
    // 当前页数
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getRole();
    },
    // 修改表头颜色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      // 改表头颜色
      if (rowIndex === 0) {
        return "background-color: #D6E4FF;color: #595959;text-align:center;";
      }
    },
    getRole() {
      this.loading = true;
      const params = {
        project_id: this.proId,
        key: this.key,
        page: this.currentPage - 1,
        page_size: this.pageSize,
      };
      getRole(params)
        .then((res) => {
          this.list();
          if (res && res.code === 0) {
            this.loading = false;
            if (res.data && res.data.length > 0) {
              this.roleData = res.data;
              this.total = res.total;
            } else {
              this.roleData = [];
            }
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    getRoleList() {
      roleList({ project_id: this.proId })
        .then((res) => {
          if (res && res.code === 0) {
            // console.info(3123123);
            this.authorityData = res.data;
            // let arr = []
            // res.data.map(item => {
            //   console.info(123123)
            //   arr = [...arr, ...item.children]
            // })
            // console.log(12312);
            // // this.authorityData = arr
            // console.log(this.authorityData);
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    addRole() {
      this.roleId = "";
      this.roleDialogVisible = true;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = {
            project_id: this.proId,
            name: this.ruleForm.name,
            code: this.ruleForm.code,
            authority: this.reqObj,
          };
          if (!this.roleId) {
            this.addRoles(params);
          } else {
            params.id = this.roleId;
            this.saveEditRole(params);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    addRoles(params) {
      this.is_loading = true;
      addRole(params)
        .then((res) => {
          if (res && res.code === 0) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.roleDialogVisible = false;
            this.cancel();
          } else {
            this.$message(res.msg);
          }
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    cancel() {
      this.ruleForm.name = "";
      this.ruleForm.code = "";
      this.ruleForm.authority = "";
      this.roleDialogVisible = false;
      this.$refs.ruleForm.resetFields();
      this.getRole();
    },
    editRole(row) {
      this.roleId = row.id;
      this.roleDialogVisible = true;
      const params = {
        project_id: this.proId,
        id: row.id,
      };
      detailRole(params)
        .then((res) => {
          if (res && res.code === 0) {
            this.ruleForm.name = res.data.name;
            this.ruleForm.code = res.data.code;
            const arr = [];
            res.data.authority_list2.map((item) => {
              // console.log(item);
              item.children.map((i) => {
                const charr = [];
                charr.push(item.label);
                charr.push(i.label);
                arr.push(charr);
              });
            });

            this.ruleForm.authority = arr;
            this.handleData(arr);
            // console.log(this.ruleForm.authority);
            // console.log(typeof this.ruleForm.authority);
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    saveEditRole(params) {
      this.is_loading = true;
      editRole(params)
        .then((res) => {
          if (res && res.code === 0) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.cancel();
          } else {
            this.$message(res.msg);
          }
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    delRole(row) {
      this.$confirm(
        `是否确认删除用户 <span style="color: #698CFC;font-size: 14px;font-weight: bold;">${row.name} </span>?`,
        "提示",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          cancelButtonClass: "btn-custom-cancel",
          type: "warning",
        }
      )
        .then(() => {
          const params = {
            id: row.id,
            project_id: this.proId,
          };
          delRole(params)
            .then((res) => {
              if (res && res.code === 0) {
                this.$message({
                  message: res.msg,
                  type: "success",
                });
                this.getRole();
              } else {
                this.$message(res.msg);
              }
            })
            .catch((res) => {
              console.log(res.msg);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>

<style scoped>
.btn {
  text-align: right;
}
.container-table {
  margin-top: 20px;
}
.title {
  padding: 15px 0;
  background-color: #d6e4ff;
  color: #595959;
  font-weight: 500;
  font-size: 16px;
}
.proInfo {
  background-color: #f0f5ff;
  padding: 20px 30px;
}
.row {
  margin: 20px 0;
  font-size: 14px;
  color: #595959;
}
.colm-left {
  line-height: 26px;
}
.pages {
  margin-top: 30px;
  text-align: right;
}
.edit {
  font-size: 12px;
  margin-right: 10px;
}
</style>
<style>
.el-dialog__header {
  padding: 0px;
}
.container-table {
  border: 1px solid #e5eeff;
}
.el-tooltip__popper.is-light {
  border: none;
  background: #ffffff;
  box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08),
    -1px -1px 12px 0px rgba(0, 0, 0, 0.12);
}
.popper__arrow {
  border: none !important;
}

.btn-custom-cancel {
  float: right;
  margin-left: 10px;
}
.el-table__column-filter-trigger i {
  color: #000;
  font-size: 14px;
}
</style>
